import type { Permission } from '@/auth/permissions';

export interface NavItem {
  to: string;
  label: string;
  permission: Permission;
  end?: boolean;
}

export interface NavSection {
  label?: string;
  items: NavItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  {
    items: [{ to: '/', label: 'Dashboard', permission: 'dashboard.view', end: true }],
  },
  {
    label: 'Customers',
    items: [
      { to: '/partners', label: 'Partners', permission: 'partners.view' },
      { to: '/orgs', label: 'Organizations', permission: 'orgs.view' },
      { to: '/direct-orgs', label: 'Direct orgs', permission: 'orgs.view' },
    ],
  },
  {
    label: 'Commercial',
    items: [
      { to: '/plans', label: 'Plans', permission: 'plans.view' },
      { to: '/usage', label: 'Usage & billing', permission: 'usage.export' },
    ],
  },
  {
    label: 'Platform',
    items: [
      { to: '/maintenance', label: 'Maintenance', permission: 'maintenance.view' },
      { to: '/audit', label: 'Audit log', permission: 'audit.view' },
      { to: '/admin-users', label: 'Admin users', permission: 'adminUsers.manage' },
    ],
  },
];
